import { render, staticRenderFns } from "./RsaPazientePrescrizioneFarmaciEditModalComponent.vue?vue&type=template&id=4ab35ddc&scoped=true"
import script from "./RsaPazientePrescrizioneFarmaciEditModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioneFarmaciEditModalComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazientePrescrizioneFarmaciEditModalComponent.vue?vue&type=style&index=0&id=4ab35ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab35ddc",
  null
  
)

export default component.exports